export enum EXPERIENCE_DURATION_DESCRIPTION {
  MINUTE = 'MINUTE',
  HOUR = 'HOUR',
  HALF_DAY = 'HALF_DAY',
  DAY = 'DAY',
}

export type ExperienceDurationDescription =
  (typeof EXPERIENCE_DURATION_DESCRIPTION)[keyof typeof EXPERIENCE_DURATION_DESCRIPTION];
